import {Component, Input, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';

@Component({
  selector: 'nf-handler',
  templateUrl: './handler.component.html',
  styleUrls: ['./handler.component.css']
})
export class HandlerComponent implements OnInit {
  dataSubscription: Subscription = null;
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  group: any = {}; // 当前组件分组数据
  pulse: any = {}; // 当前组件行数据
  column: any = {}; // 当前组件列数据
  @Input('nfBoardData') set ChangeBoardData(data: any) {
    if (data) {
      this.boardData = data;
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
    }
  }
  @Input('nfColumnData') set ChangeColumnData(data: any) {
    if (data) {
      this.column = data;
    }
  }
  @Input('nfPulseData') set ChangePulseData(data: any) {
    if (data) {
      this.pulse = data;
    }
  }
  constructor() { }

  ngOnInit(): void {
    if (this.pulse.columnValues[this.column.id] && this.pulse.columnValues[this.column.id].personsAndTeams) {
      const hash = {};
      this.pulse.columnValues[this.column.id].personsAndTeams = this.pulse.columnValues[this.column.id].personsAndTeams.reduce((item, next) => {
        hash[next.id] ? '' : hash[next.id] = true && item.push(next);
        return item;
      }, []);
    }
  }

}
